import React from 'react';

type Props = {
  center?: boolean;
  ext?: string;
};

const LoggedOutFooter: React.FC<Props> = ({ center = false, ext }) => {
  return (
    <footer
      className={['flex', center ? 'justify-center' : 'justify-start'].join(
        ' ',
      )}
    >
      <div
        className={['flex flex-col', center ? 'items-center' : ''].join(' ')}
      >
        <div>
          <p className="flex flex-col">
            <span>Questions? Talk to our team directly:</span>
            <span className="text-primary-500 font-bold">
              (844) 462-4476{!!ext && ` EXT. ${ext}`}
            </span>
          </p>
        </div>
        <div className="flex flex-row gap-2 pb-6">
          <a
            href="https://help.chiroup.com/en_US/Security-and-privacy/terms-of-use"
            target="_blank"
            rel="noreferrer"
          >
            <p className="text-sm text-primary-500">Terms of use</p>
          </a>
          <span className="text-sm text-gray-400">|</span>
          <a
            href="https://help.chiroup.com/en_US/Security-and-privacy/1136907-view-the-chiroup-privacy-policy"
            target="_blank"
            rel="noreferrer"
            className="pb-6"
          >
            <p className="text-sm text-primary-500">Privacy policy</p>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default LoggedOutFooter;
